import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { Config, Path } from '../../../enums';
import { USER_MGMT_CNST, USER_MGMT_DEFAULT_CONFIG_CNST } from '../../../constants/proj.cnst';
import { AppStateService } from '../../../services/app-state.service';
import { UtilsService } from '../../../services/utils.service';
import { HttpService } from '../../../services/http.service';
import { EnvService } from '../../../services/env.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class ForgotpasswordComponent implements OnInit {


  forgotPasswordForm: FormGroup;
  submitted: boolean = false;
  displayErrorMessage: string = "";
  activespiner: boolean = true;
  forgotPasswordConfig : any = {};
  constant : any = {};
  diVisible:boolean = false;
  isInvalidUsername: boolean = false;
  dataSub:any
  
  constructor(
    private fb: FormBuilder,
    private appState: AppStateService,
    private authSrv: AuthenticationService,
    private cmnSrv : CommonService,
    private router: Router,
    private utilsServ: UtilsService,
    private httpSrv: HttpService,
    private envService : EnvService,
    private modalService: NgbModal) {
    this.forgotPasswordForm = fb.group({
      'userName': ['', Validators.required],
    })
  }

  ngOnInit() {
    this.constant = USER_MGMT_DEFAULT_CONFIG_CNST.FORGOT_PSWD_CONST;
    this.loadConfig();
    this.dataSub = this.forgotPasswordForm.valueChanges.subscribe((value:any) => {
      this.isInvalidUsername = false;
    });
  }

  ngOnDestroy(){
    this.dataSub.unsubscribe()
  }

  async loadConfig() {
    this.forgotPasswordConfig = await this.cmnSrv.loadConfig({path:Path.FORGOT_PASSWD_CONFIG_PATH,configType:Config.FORGOT_PASSWD_CONFIG});
    this.diVisible = true;
    this.activespiner = false;
  }

  get formControl() {
    return this.forgotPasswordForm.controls;
  }

  //On click Cancel Button
  cancel() {
    this.router.navigate(USER_MGMT_CNST.COMMON_ROUTE_MAPPING.LOGIN);
  }
  // Returning post parameters for OTP sending API
  getPostParams() {
    const postData = {
      'username': this.forgotPasswordForm.value['userName']
    }
    return postData
  }

  logout() {
    this.authSrv.setUserInfo(null, ("null" as string));
    this.appState.setPermissionsLoaded(false);
    this.appState.setInProcess(false);
    this.appState.setUserMetaInfo({});
    this.appState.setUserPermissionsRef({});
    this.router.navigate(USER_MGMT_CNST.COMMON_ROUTE_MAPPING.LOGIN);
  }
  //API for Sending OTP
  async otpSendAPI() {
    const postData = this.getPostParams();
    let response = await this.utilsServ.makeOtpSendApiCall('OTP_SEND', postData)
    this.activespiner = false;
    if (!response) {
      this.displayErrorMessage = "Invalid Credentials"
      return
    }

  }
  //Submitting Data
  handleForgotPassword() {
    this.submitted = true;
    this.activespiner = true;
    this.displayErrorMessage = "";

    if (this.forgotPasswordForm.invalid) {
      this.activespiner = false;
      return;
    }
    this.otpSendAPI()
  }
  onsubmit(){
    const isEmail = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.forgotPasswordForm.getRawValue()?.userName);
    let options = { uriParams: { username:this.forgotPasswordForm.getRawValue()?.userName } };
    this.httpSrv.makeGetApiCall('FORGOT_PASSWORD',this.envService.baseUrl,options).subscribe({
      next: (response: any) => {
        if(response?.statusCode !=404){
          this.utilsServ.showToastMessage("Email Sent successfully", "success");
          this.logout();
        }else{
          this.isInvalidUsername = true;
        }
      },
      complete: () => {},
      error: (err: any) => {
        this.utilsServ.showToastMessage("Error in forgot password", "error");
      }
    });
  }
}
